import { inject, Injectable, InjectionToken } from '@angular/core';

export interface Environment {
  production: boolean;
  version?: string;
  aiEnabled?: boolean;
  enableMsal?: boolean;
}

export const ENVIRONMENT = new InjectionToken<Environment>('environment');

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  environment = inject(ENVIRONMENT, { optional: true });

  get production(): boolean {
    return this.environment?.production ?? false;
  }

  get version(): string {
    return this.environment?.version ?? '';
  }
  get aiEnabled(): boolean {
    return this.environment?.aiEnabled ?? false;
  }

  get enableMsal(): boolean {
    return this.environment?.enableMsal ?? false;
  }
  getEnvironment(): Environment {
    return this.environment ?? { production: false };
  }
  getTopBarIdentifier(): string {
    return (this.environment as any)?.topBarIdentifier ?? 'top-bar';
  }
}
